import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  ruleList: [],
  isLoadingUpdate: false,
  allRules: [],
  activeKey: 0,
  isLoadingAnalysis: false,
  analysisResult: {},
  isLoadingDetails: false,

  valueDuplicate: [],
  isLoadingValueDuplicate: false,
  valueDuplicateMeta: {
    currentPage: 1,
    recordPerPage: 10,
    hasMore: true,
  },
  recordDuplicateDetail: [],
  isLoadingRecordDuplicateDetail: false,
  recordDuplicateDetailMeta: {
    currentPage: 1,
    recordPerPage: 10,
    hasMore: true,
  },
  activeValueID: "",
  fieldsDuplicateDetail: [],

  selectedRowKeysMerge: [],
  recordToMerge: {},
};

const slice = createSlice({
  name: "duplicateRules",
  initialState,
  reducers: {
    loadAllRules(state, action) {
      state.isLoading = true;
    },
    loadAllRulesSuccess(state, action) {
      state.isLoading = false;
      state.allRules = action.payload;
    },
    loadRules(state, action) {
      state.isLoadingDetails = true;
      state.ruleList = [];
    },
    loadRulesSuccess(state, action) {
      state.ruleList = action.payload;
    },
    loadRulesFail(state, action) {},
    setLoadingDetails(state, action) {
      state.isLoadingDetails = action.payload;
    },
    updateRules(state, action) {
      state.isLoadingUpdate = true;
    },
    updateRulesSuccess(state, action) {
      state.isLoadingUpdate = false;
    },
    updateRulesFail(state, action) {
      state.isLoadingUpdate = false;
    },
    updatePosition(state, action) {},
    actionDuplicate(state, action) {},
    deleteDuplicate(state, action) {},
    createRules(state, action) {},
    createDuplicate3rd() {},
    updateDuplicate3rd() {},
    notify() {},
    setActiveKey(state, action) {
      state.activeKey = action.payload;
    },
    runAnalysis(state) {
      state.isLoadingAnalysis = true;
    },
    runAnalysisResult(state, action) {
      state.isLoadingAnalysis = false;
      state.analysisResult = action.payload;
    },
    downloadAnalysis() {},
    loadValueDuplicate(state) {
      state.isLoadingValueDuplicate = true;
    },
    loadValueDuplicateResult(state, action) {
      state.isLoadingValueDuplicate = false;

      if (action.payload.length < 10) {
        state.valueDuplicateMeta.hasMore = false;
      }

      if (state.valueDuplicateMeta.currentPage === 1) {
        state.valueDuplicate = action.payload;
      } else {
        state.valueDuplicate = [...state.valueDuplicate, ...action.payload];
      }
    },
    setValueDuplicateMeta(state, action) {
      state.valueDuplicateMeta = action.payload;
    },
    loadRecordDuplicateDetail(state) {
      state.isLoadingRecordDuplicateDetail = true;
    },
    loadRecordDuplicateDetailResult(state, action) {
      state.isLoadingRecordDuplicateDetail = false;
      state.recordDuplicateDetail = action.payload;
      if (action.payload.length < 10) {
        state.recordDuplicateDetailMeta.hasMore = false;
      }
    },
    setRecordDuplicateDetailMeta(state, action) {
      state.recordDuplicateDetailMeta = action.payload;
    },
    loadFieldsDuplicateDetail() {},
    loadFieldsDuplicateDetailResult(state, action) {
      state.fieldsDuplicateDetail = action.payload;
    },
    setActiveValueID(state, action) {
      state.activeValueID = action.payload;
    },
    updateSettingAnalysis() {},
    setSelectedRowKeysMerge(state, action) {
      state.selectedRowKeysMerge = action.payload;
    },
    setRecordToMerge(state, action) {
      state.recordToMerge = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  loadRules,
  loadRulesFail,
  setLoadingDetails,
  loadRulesSuccess,
  updateRules,
  updateRulesSuccess,
  updateRulesFail,
  updatePosition,
  actionDuplicate,
  deleteDuplicate,
  createRules,
  createDuplicate3rd,
  updateDuplicate3rd,
  notify,
  loadAllRules,
  loadAllRulesSuccess,
  setActiveKey,
  runAnalysis,
  runAnalysisResult,
  downloadAnalysis,
  loadValueDuplicate,
  loadValueDuplicateResult,
  setValueDuplicateMeta,
  loadRecordDuplicateDetail,
  loadRecordDuplicateDetailResult,
  setCurrentPageValueDuplicate,
  setRecordDuplicateDetailMeta,
  loadFieldsDuplicateDetail,
  loadFieldsDuplicateDetailResult,
  setActiveValueID,
  updateSettingAnalysis,
  setSelectedRowKeysMerge,
  setRecordToMerge,
} = slice.actions;
